import React from "react";
import Window from "./Window";

import "./ChooseAvatar.css";
import { Controller } from "../core/Controller";

export default class ChooseAvatar extends React.Component<ChooseAvatar.Props, ChooseAvatar.State>
{


    constructor(props: ChooseAvatar.Props)
    {
        super(props)
    }


    clickAvatar(avatar: string)
    {
        Controller.setAvatarForUser(Controller.player.id, avatar);
        app.closeLastWindow();
    }


    close()
    {
        app.closeLastWindow();
    }


    render()
    {
        const lang = window.lang.shared;

        return (
            <Window
                id="chooseAvatar"
                title={lang.modals["game-avatar"].title}
            >
                <div className="container">
                    {this.renderAvatars()}
                </div>
                <div className="footer">
                    <div
                        className="button"
                        onClick={this.close.bind(this)}
                    >
                        {lang.close}
                    </div>
                </div>
            </Window>
        )
    }


    renderAvatars()
    {
        const arr: Array<JSX.Element> = []

        const my = Controller.getAvatarForUser(Controller.player.id);

        for (let i = 1; i <= 72; i++)
        {
            const isme = i.toString() == my;
            arr.push(
                <div
                    className={"item " + (isme ? "selected" : "")}
                    onClick={isme ? null : this.clickAvatar.bind(this, i.toString())}
                >
                    <img
                        src={"gfx/avatars/av-" + i + ".png?version=" + version}
                    />
                </div>
            );
        }

        return arr;
    }


}


export namespace ChooseAvatar
{


    export interface Props
    {

    }


    export interface State
    {

    }


}